import logs from "@/api/logs";

export default {
    state: {
    },

    mutations: {
    },

    actions: {
        async retrieveLogs(context, { count, lastId = null, skip = 0 }) {
            try {
                let params = {
                    management_id: await context.dispatch("showManagementID"),
                    count: count,
                };
                if (lastId) {
                    params.latest_log_id = lastId;
                }
                if (skip > 0) {
                    params.skip_page = skip;
                }
                let res = await logs.index(params);
                return res.data.data;
            } catch (error) {
                throw error;
            }
        },
        async retrieveAllLogs(context) {
            try {
                let params = {
                    management_id: await context.dispatch("showManagementID"),
                };
                let res = await logs.index(params);
                return res.data.data;
            } catch (error) {
                throw error;
            }
        },
        async deleteLogs(context, { managementId, logId }) {
            try {
                let params = {
                    account_id: await context.dispatch("showAccountID"),
                    user_id: await context.dispatch("showUserId"),
                    management_id: managementId,
                    log_id: logId
                };
                await logs.del(params);
            } catch (error) {
                console.log(error);
            }
        }
    },

    getters: {
    },
};
